import http from "../config/axiosConfig/http-common";
import ServiceBase from "./service.base";

class CondicaoPagamentoService extends ServiceBase {

  getAll(filter) {
    return http.get("/condicoespagamento" + this.getFilter(filter));
  }

  get(id) {
    return http.get(`/condicoespagamento/${id}`);
  }

}

export default new CondicaoPagamentoService();